module.exports = __webpack_public_path__ + "static/android2-daec9481d611eb4784d33832c86a6d3b.jpg";